import React, { createContext, useState } from 'react';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [fromBookstore, setFromBookstore] = useState(false);

  return (
    <AppContext.Provider value={{ fromBookstore, setFromBookstore }}>
      {children}
    </AppContext.Provider>
  );
};
